module.exports = require("react-router-redux");


//////////////////
// WEBPACK FOOTER
// external "react-router-redux"
// module id = 19
// module chunks = 0